import React, { useEffect } from "react";
import Header from "../../common/header/header";
import TruestedImage from "../../assets/media/images/truested-banner-img.png";
import AboutImage from "../../assets/media/images/about-sec-img.png";
import MissionImage from "../../assets/media/images/mission-image.png";
import VisionImage from "../../assets/media/images/vision-image.png";
import { address_icons, email_icons, phone_icons } from "../../api/baseUrl";
import { Accordion } from "@mantine/core";
import { Button } from '@mantine/core';
import { IconPlus } from "@tabler/icons-react";

const About = () => {

    
  const groceries = [
    {
      emoji: "01",
      value: "Privacy Policy",
      description: `<p>At Akseer, we prioritize and highly value your privacy.</p>
            <p>Akseer is committed to safeguarding your privacy, ensuring the transparent and responsible handling of personal information. At the core of Akseer’s principles is prioritizing the privacy of our website visitors. We collect your personal information with the primary goal of offering you tailored products and services, and to foster a meaningful and effective relationship with you. Every step of additional personal information collection is aligned with these fundamental purposes, ensuring a comprehensive and secure approach to your privacy.</p>`,
    },
    {
      emoji: "02",
      value: "Collection of Information",
      description: `<p>When you visit Akseer's website, we may collect your personal information, which you voluntarily provide, such as your name, email address, and other contact details. This includes information obtained when you sign up for newsletters, create an account, fill out forms on our website, or register for job opportunities through the Akseer Job Portal, request service information or consultation, and register for newsletters.The collected personal data varies and may encompass information such as your name, address, email address, telephone number, fax number, and background details necessary for job applications.</p>`,
    },
    {
      emoji: "03",
      value: "Use of information",
      description: `<p>We can use your data for the following purposes:</p>
            <ul><li>We gather and securely store the data you voluntarily provide, this collected data serves as the foundation for tailoring personalized solutions that precisely meet your specific needs.</li>
            <li>We may use your personal information to contact you in situations where you have requested specific information, for instance if you have subscribed to our newsletter.</li>
            <li>We may utilize your personal details to send you exclusive promotional offers and to keep you informed through various marketing communications. These communications may include updates about our products, services, special promotions, and other relevant information designed to enhance your experience with our offerings.</li>
            <li>We may utilize your data to reach out to you if you've applied for a job. This contact is for recruitment and assessment purposes in connection with job applications.</li>
            <li>We may utilize your personal details for purposes beyond those initially disclosed. Rest assured, your information will only be used if permitted by law.</li></ul>`,
    },
    {
      emoji: "04",
      value: "Online Privacy Policy Only",
      description: `<p>The purpose of this Privacy Policy is to clarify our practices regarding the collection, use, disclosure, and safeguarding of your personal information when you visit our website. This policy specifically pertains to information collected through www.akseerresearch.com.</p>
            <p>It does not extend to any information collected offline or through channels other than this website.</p>`,
    },
    {
      emoji: "05",
      value: "Consent",
      description:
        "<p>By using our website, you hereby consent to our Privacy Policy.</p>",
    },
    {
      emoji: "06",
      value: "Amendments",
      description:
        "<p>Akseer reserves the right to modify the Privacy Policy or its components at any time.</p>",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const items = groceries.map((item) => (
    <Accordion.Item key={item.value} value={item.value}>
      <Accordion.Control icon={item.emoji}>{item.value}</Accordion.Control>
      <Accordion.Panel>
        <div dangerouslySetInnerHTML={{ __html: item.description }} />
      </Accordion.Panel>
    </Accordion.Item>
  ));

  return (
    <div className="features-screen">
      <Header />
      {/* trusted research box */}
      <div className="truested-boxed">
        <div className="truested-heading">
          <h1>Your trusted source for cutting-edge fundamental research.</h1>
        </div>
        <div className="truested-img">
          <img src={TruestedImage} alt="" />
        </div>
      </div>
      {/* about full screen image */}
      <div className="about-full-sreen">
        <img src={AboutImage} alt="" />
      </div>
      {/* Mission section */}
      <div className="mission-vision-box">
        <div className="mission-section vission-section">
          <div className="mission-vision-sec">
            <div className="row m-auto">
              <div className="col-md-6 m-auto">
                <div className="mission-content">
                  <h1>Mission</h1>
                  <p>
                    To provide investors and financial experts with the tools
                    they need to make smarter, faster, and more informed
                    investment decisions.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mission-image">
                  <img src={MissionImage} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mission-section vission-section">
          <div className="mission-vision-sec">
            <div className="row m-auto">
              <div className="col-md-6">
                <div className="mission-image vision-img">
                  <img src={VisionImage} alt="" />
                </div>
              </div>
              <div className="col-md-6 m-auto pl-0">
                <div className="mission-content vision-content">
                  <h1>Vision</h1>
                  <p>
                    To drive the future of stock market analysis by focusing on
                    clarity, relevance, and unparalleled research experiences
                    for all users.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* reach out in section */}
      <div className="reach-out">
        <div className="container">
          <div className="reach-content">
            <h1>Reach out to us today</h1>
            <p>
              Whether you need support or want to learn more, we’re here to
              assist you
            </p>
          </div>
          <div className="reach-boxes">
            <div className="email-phone-box">
              <div
                className="reach-icons-stroke"
                dangerouslySetInnerHTML={{
                  __html: email_icons,
                }}
              />
              <div className="reach-out-content">
                <h1>Email</h1>
                <p>support@askanalyst.pk</p>
              </div>
            </div>
            <div className="email-phone-box">
              <div
                className="reach-icons-stroke"
                dangerouslySetInnerHTML={{
                  __html: phone_icons,
                }}
              />
              <div className="reach-out-content">
                <h1>Phone</h1>
                <p>+92 21 34320359</p>
              </div>
            </div>
            <div className="email-phone-box">
              <div
                className="reach-icons-stroke"
                dangerouslySetInnerHTML={{
                  __html: address_icons,
                }}
              />
              <div className="reach-out-content">
                <h1>Address</h1>
                <p>1st Floor, Shaheen Chambers, KCHS, Block 7 & 8</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* frequently asked in section */}
      <section className="frequently-question-sec">
          <div className="container">
            <div className="privacy_content">
                <h1>Frequently Asked Questions</h1>
            </div>
            <div className="accordion_sec privacy-pages">
              <Accordion defaultValue="Privacy Policy" chevron={<IconPlus />}>
                {items}
              </Accordion>
            </div>
          </div>
        </section>

        <section className="discover-section">
            <div className="discover-content">
                <div className="container">
                    <div className="discover-heading">
                        <h1>Discover how AskAnalyst can help you in your investment journey.</h1>
                        <Button className="get-started-btn">Get Started</Button>
                    </div>
                </div>
            </div>
        </section>
    </div>
  );
};

export default About;
